// import React from "react";
// import action from '../../assets/images/Dashboard/action-img.svg';
// import edit from '../../assets/images/Dashboard/edit-img.svg';
// import view from '../../assets/images/Dashboard/view-img.svg';

// function SbActionDropdownButton(props) {
//     return (
//         <div className="dropdown add-single-bulk">
//             <button
//                 className="btn btn-action-dropdown"
//                 id="adduser-single-blulk"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//             >
//                 <div className="btn-inline-item d-flex align-items-center">
//                     <img src={action} alt="" />
//                 </div>
//             </button>
//             <ul
//                 className="dropdown-menu single-bulk-upload"
//                 aria-labelledby="adduser-single-blulk"
//             >
//                 <li>
//                     <button
//                         className="dropdown-item single-user"
//                         onClick={props.openAddModal}
//                     >
//                         <img src={edit} alt="" /> &nbsp; Edit Details {props.pageName}
//                     </button>
//                 </li>
//                 <li>
//                     <button
//                         className="dropdown-item bulk-user"
//                         onClick={props.addBulkModel}
//                     >
//                         <img src={view} alt="" /> &nbsp; View Details
//                     </button>
//                 </li>
//             </ul>
//         </div>
//     );
// }

// export default SbActionDropdownButton;



import React from "react";
import action from '../../assets/images/Dashboard/action-img.svg';
import edit from '../../assets/images/Dashboard/edit-img.svg';
import view from '../../assets/images/Dashboard/view-img.svg';
import attachment from '../../assets/images/Dashboard/attachment-download-img.svg';
import assignToImg from '../../assets/images/Complaint&Escalations/assignTo.svg'
import crossmark from '../../assets/images/CustomerManagement/crossmark.svg';

function SbActionDropdownButton(props) {
    const { btnName, options, openAddModal, addBulkModel, addAttachmentModal, assignToModal, pageName, customerAttachedFileName, AssignedToUser, Status, signInType, achievedPercentage, viewHistoryModal, moduleData = {}, updateScoreModal, viewJsonModal, cancelServiceRequest, ReportedByUserID, statusId } = props

    // Determine which options to display
    const displayOptions = () => {
        if (options && Array.isArray(options) && options.length > 0) {
            return options.map((option, index) => {
                switch (option.type) {
                    case 'Edit':
                        // // Hide "Update Score" if Achieved Percentage is 100
                        // if (Number(achievedPercentage) === 100) {
                        //     return null;
                        // }

                        // // Hide "Update Score" if Achieved Percentage is 100
                        // const hideUpdateScore = signInType === "User" && Number(achievedPercentage) === 100;
                        // Hide "Edit Details" if moduleData?.CanUpdate is false
                        const hideEditDetails = signInType !== "User" && moduleData?.CanUpdate === false;

                        // if (hideUpdateScore || hideEditDetails) {
                        //     return null;
                        // }

                        if (hideEditDetails) {
                            return null;
                        }

                        return (
                            <li key={index}>
                                <button
                                    className="dropdown-item single-user"
                                    onClick={openAddModal}
                                >
                                    <img src={edit} alt="Edit" /> &nbsp; Edit Details {pageName}
                                    {/* <img src={edit} alt="Edit" /> &nbsp; {signInType === "User" ? "Update Score" : `Edit Details `} {pageName} */}
                                </button>
                                <hr />
                            </li>
                        );
                    case 'View':
                        return (
                            <li key={index}>
                                <button
                                    className="dropdown-item bulk-user"
                                    onClick={addBulkModel}
                                >
                                    <img src={view} alt="View" /> &nbsp; View Details
                                </button>
                                <hr />
                            </li>
                        );
                    case 'Download':
                        // Conditionally render the Download button
                        if (!customerAttachedFileName || customerAttachedFileName === "") {
                            return null;  // Hide Download option if no attached file name
                        }
                        return (
                            <li key={index}>
                                <button
                                    className="dropdown-item download-user"
                                    onClick={addAttachmentModal} // Replace with your download function
                                >
                                    <img src={attachment} alt="Download" /> &nbsp; Download
                                </button>
                                <hr />
                            </li>
                        );

                    case 'AssignTo':
                        if (Status === "Resolved") {
                            return null; // Don't show 'Assign To' or 'Re-assign' if status is 'Resolved'
                        }
                        if (Status === "Closed") {
                            return null; // Don't show 'Assign To' or 'Re-assign' if status is 'Resolved'
                        }
                        if (statusId === 40) {
                            return null;
                        }
                        // Show the Assign To or Re-assign button only for SuperAdmin
                        // if (signInType === "SuperAdmin") {
                        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails')) || [];

                        if (
                            (signInType === "SuperAdmin") ||
                            // (signInDetails[0]?.RoleIDs === "20" && signInDetails[0]?.CompanyID === 25)
                            (signInDetails[0]?.RoleIDs?.split(',').map(role => role.trim()).includes("20") &&
                                signInDetails[0]?.CompanyID === 25)
                        ) {
                            // Conditionally render the Assign To button only if AssignedToUser is null or empty
                            // if (AssignedToUser && AssignedToUser !== "") {
                            if (statusId === 68 || statusId === 39) {
                                return (
                                    <li key={index}>
                                        <button
                                            className="dropdown-item assign-to-user"
                                            onClick={assignToModal} // Add the function to open the "Re-assign" modal
                                        >
                                            <img src={assignToImg} alt="Re-assign" /> &nbsp; Re-assign
                                        </button>
                                    </li>
                                );
                            }
                            // if (Status && Status === "Resolved") {
                            //     return (
                            //         <li key={index}>
                            //             <button
                            //                 className="dropdown-item assign-to-user"
                            //                 onClick={assignToModal} // Add the function to open the "Re-assign" modal
                            //             >
                            //                 <img src={assignToImg} alt="Assign To QA" /> &nbsp; Assign To QA
                            //             </button>
                            //         </li>
                            //     );
                            // }
                            return (
                                <li key={index}>
                                    <button
                                        className="dropdown-item assign-to-user"
                                        onClick={assignToModal} // Add the function to open the "Assign To" modal
                                    >
                                        <img src={assignToImg} alt="Assign To Technical" /> &nbsp; Assign To
                                    </button>
                                </li>
                            );
                        }
                        return null;
                    case 'ViewHistory':
                        return (
                            <li key={index}>
                                <button className="dropdown-item history-user" onClick={viewHistoryModal}>
                                    <img src={view} alt="History" /> &nbsp; View History
                                </button>
                                <hr />
                            </li>
                        );
                    case 'ViewJSON':
                        return (
                            <li key={index}>
                                <button className="dropdown-item history-user" onClick={viewJsonModal}>
                                    <img src={view} alt="History" /> &nbsp; View JSON
                                </button>
                                <hr />
                            </li>
                        );
                    case 'Cancel SR':
                        const SignInDetails = JSON.parse(sessionStorage.getItem('SignInDetails')) || [];
                        const loggedInUserID = SignInDetails[0]?.UserID;

                        // Show only if status is "Pending" AND reported by current user
                        if (ReportedByUserID !== loggedInUserID || Status !== "Pending") {
                            return null;
                        }

                        return (
                            <li key={index}>
                                <button
                                    className="dropdown-item bulk-user"
                                    onClick={cancelServiceRequest}
                                >
                                    <img src={crossmark} alt="crossmark" /> &nbsp; Cancel SR
                                </button>
                                <hr />
                            </li>
                        );
                    case 'UpdateScore':  // New button case for "Update Score"
                        if (signInType === "User") {
                            return (
                                <li key={index}>
                                    <button className="dropdown-item score-user" onClick={updateScoreModal}>
                                        <img src={edit} alt="Update Score" /> &nbsp; Update Score
                                    </button>
                                    <hr />
                                </li>
                            );
                        }
                        return null;

                    default:
                        return null;
                }
            });
        } else {
            // Default to showing both options if no `options` prop is provided
            return (
                <div className="action-button-div">
                    {!(signInType === "User" && Number(achievedPercentage) === 100) &&
                        !(signInType !== "User" && moduleData?.CanUpdate === false) && (
                            <li>
                                <button
                                    className="dropdown-item single-user"
                                    onClick={openAddModal}
                                >
                                    {/* <img src={edit} alt="Edit" /> &nbsp; Edit Details {pageName} */}
                                    <img src={edit} alt="Edit" /> &nbsp; {signInType === "User" ? "Update Score" : `Edit Details `} {pageName}
                                </button>
                            </li>
                        )}
                    <hr />
                    <li>
                        <button
                            className="dropdown-item bulk-user"
                            onClick={addBulkModel}
                        >
                            <img src={view} alt="View" /> &nbsp; View Details
                        </button>
                    </li>
                </div>
            );
        }
    };

    return (
        <div className="dropdown add-single-bulk">
            <button
                className="btn btn-action-dropdown"
                id="action-dropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <div className="btn-inline-item d-flex align-items-center">
                    <img src={action} alt="Action" />
                    &nbsp;&nbsp;
                    {btnName}
                </div>
            </button>
            <ul
                className="dropdown-menu single-bulk-upload"
                aria-labelledby="action-dropdown"
            >
                {displayOptions()}
            </ul>
        </div>
    );
}

export default SbActionDropdownButton;

